import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  UploadFile,
  UploadProps,
  message,
} from "antd";
import Modal from "antd/lib/modal/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getFilesCategories, pollStatusFileAdmin, validateFile } from "../../../core/store/reducers/files.slice";
import Upload, { RcFile } from "antd/lib/upload";
import { uploadFilePath, uploadFilePathAdmin } from "../../../core/store/reducers/upload.slice";
import axios from "axios";
import { convertFileSizeFromBytes } from "../../../shared/utilities";
import PopupMessageComponent from "../../../shared/layouts/message.layout";
import { readAsArrayBufferAsync } from "../../FileConfiguration/components/admin-document-upload.components";
import { putAudienceCreateCsv, uploadFilePathAudience } from "../../../core/store/reducers/annoucements.slice";
import { useHistory, useParams } from "react-router-dom";
import { ROUTE_ANNOUNCEMENTS, ROUTE_ANNOUNCEMENTS_CONFIG } from "../../../core/route/ui.routes";

function CreateAudienceCSV({ formVisible, setFormVisible, selectedAudience, returnType= 1, reloadList = ()=>{} }: any) {
  const dispatch = useDispatch();
  const params: any = useParams();
  const history = useHistory();
  const [audienceId, setAudienceId] = useState(params?.id as any);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileListData, setFileListData] = useState([] as any);
  const [errorFileListData, setErrorFileListData] = useState([] as any);
  const [uploading, setUploading] = useState(false);
  const [audienceName, setAudienceName] = useState(null as any);
  const [modalVisible, setModalVisible] = useState(false as any);
  const [modalType, setModalType] = useState("" as any);
  const [modalButtons, setModalButtons] = useState((<></>) as any);
  const [modalTitle, setModalTitle] = useState("" as any);
  const [modalSubTitle, setModalSubTitle] = useState("" as any);
  useEffect(()=>{
    if(selectedAudience){
      setAudienceName(selectedAudience.audience_name)
      setAudienceId(selectedAudience.audience_id)
      form.setFieldValue('audiencename', selectedAudience.audience_name)
    }
  }, [selectedAudience])
  
  const handleUpload = async (file: any, ext: string) => {
    try {
      const filename = file.name.split("."+ext).join("");
      const response = await dispatch(
        uploadFilePathAudience({
          filename: filename
        })
      );
      if(!response?.payload?.data?.data){
        removeFile();
        message.error("Something went wrong.", 10);
      }
      const {
        data: {
          data: { blobname, url },
        },
      } = response.payload;
      try {
        const binaryFile = await readAsArrayBufferAsync(file as RcFile);
        setUploading(true);
        const payload:any = {
          headers: { "Content-Type": file.type || "", "x-ms-blob-type": "BlockBlob" },
          method: "PUT",
          data: binaryFile,
          url: url,
          timeout: 0,
        }
        const fileUploaded = await axios.request(payload);
        if (fileUploaded.status === 200 || fileUploaded.status === 201) {
          setUploading(false);
          setFileListData([{ file, csv_filename: blobname, filename, url, fileUploaded: 1 }]);
        }
      } catch (e) {
        removeFile();
        setUploading(false);
        message.error("Something went wrong.", 10);
      }
    } catch (e) {
      removeFile();
      setUploading(false);
      message.error("Something went wrong.", 10);
    }
  };
  const removeFile = () => {
    setFileList([]);
    setFileListData([]);
    setErrorFileListData([]);
  };
  const props: UploadProps = {
    showUploadList: false,
    onRemove: (file) => {
      removeFile();
    },
    beforeUpload: (file) => {
      const maxSizeInBytes = 5 * 1024 * 1024; // 2 MB in bytes
      if (file.size > maxSizeInBytes) {
        message.warning("File size must be up to 5 MB", 10);
        setErrorFileListData([{ file }]);
        return false;
      }
      if (fileListData.length >= 2) {
        message.warning("You can only upload max 1 files", 10);
        return false;
      }
      const { name } = file;
      let ext: any = name?.split(".");
      ext = ext?.length > 0 ? ext[ext.length - 1] : "";
      if (["csv"].includes(ext)) {
      } else {
        message.error("Uploaded file is not valid", 10);
        return;
      }

      setFileList([file]);
      setFileListData([{ file }]);
      handleUpload(file, ext);
      return false;
    },
    maxCount: 1,
    fileList,
  };
  const onFormValuesChange = (data: any) => {
    if (data?.audiencename) {
      setAudienceName(data?.audiencename);
    }
  };
  
  
  const closeModalPopup = () => {
    setModalVisible(false);
    setModalType("");
    setModalButtons(<></>);
    setModalSubTitle("");
    setFormVisible(false);
    setModalTitle("");
    if(returnType == 1 )
      history.push(ROUTE_ANNOUNCEMENTS_CONFIG)
    else
      reloadList()
  };
  const openSuccessModal = () => {
    setModalTitle("File Uploaded");
    setModalType("success");
    setModalSubTitle("");
    setModalButtons(<></>);
    setModalVisible(true);
  };
  
  const onSave = async () => {
    const payload = {
      ...(audienceId ? { audience_id: audienceId } : {}),
      audience_name: audienceName,
      csv_filename: fileListData[0].csv_filename,
      filename:fileListData[0].file.name
    };
    const res = await dispatch(putAudienceCreateCsv(payload));
    
    if(res?.payload?.status == 200){
      openSuccessModal()
    }else{
      message.error("Some error occured while uploading file", 10)
    }    
  }
  function downloadTemplate(){
    let csvContent = "data:text/csv;charset=utf-8,Employee Code";
    var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  }
  return (
    <>
      <Modal
        open={formVisible}
        onCancel={() => setFormVisible(false)}
        footer={false}
        title={selectedAudience ? "Edit Audience" : "Create New Audience"}
        className="modalFormButton form-modal"
        style={{ paddingBottom: "0px" }}
        centered={true}
      >
        <Form
          className="app-form p-4"
          form={form}
          name={"csv_form"}
          onValuesChange={onFormValuesChange}
          initialValues={{audiencename: audienceName}}
        >
          <Row gutter={20} align="bottom">
            <Col span={15}>
              <Form.Item
                label="Audience Name"
                name="audiencename"
                rules={[{ required: true, message: "Audience Name is required" }]}
              >
                <Input placeholder="Enter Audience Name" />
              </Form.Item>
            </Col>
            <Col span={9}>
              <a onClick={downloadTemplate}><Button className="mb-3" block type="primary">Download Template</Button></a>
            </Col>
            <Col span={24}>
              {fileListData?.length == 0 && errorFileListData?.length == 0 && (
                <div className="admin-upload-component p-4">
                  <img
                    src={
                      require("../../../assets/icons/cloud-upload.svg").default
                    }
                    width="140"
                  />
                  <p className="title m-0">Upload CSV File</p>
                  <p className="sub-text m-0">(Max file size allowed 5Mb)</p>
                  <Upload {...props}>
                    <Button
                      disabled={!audienceName || audienceName == ''}
                      loading={uploading}
                      type="primary"
                      className="mt-4"
                    >
                      Select File
                    </Button>
                  </Upload>
                </div>
              )}
              {(fileListData?.length == 1 ||
                errorFileListData?.length == 1) && (
                <>
                  <div className="ant-form-item-label">
                    <label>CSV File</label>
                  </div>
                  <div
                    className={`admin-file-component ${
                      errorFileListData?.length == 1 ? "danger" : ""
                    }`}
                  >
                    <Row align="middle" gutter={12} className="pb-2">
                      <Col flex="none">
                        <img
                          src={
                            require("../../../assets/icons/file-type-excel.svg")
                              .default
                          }
                          height={50}
                        />
                      </Col>
                      <Col flex="auto">
                        <p className="title m-0">
                          {fileListData[0]?.file?.name ||
                            errorFileListData[0]?.file?.name}
                        </p>
                        <p className="sub-text m-0">
                          {convertFileSizeFromBytes(
                            fileListData[0]?.file?.size ||
                              errorFileListData[0]?.file?.size
                          )}{" "}
                          {fileListData?.length == 1 && `• File Uploaded`}
                        </p>
                      </Col>
                      <Col flex="none">
                        <Row>
                          <Col>
                            <Button
                              type="link"
                              onClick={removeFile}
                              icon={
                                <img
                                  src={
                                    require("../../../assets/icons/close.svg")
                                      .default
                                  }
                                />
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            {fileListData?.length == 1 && !fileListData[0].csv_filename && (
                              <span className={`percent success`}>0%</span>
                            )}
                            {fileListData?.length == 1 && fileListData[0].csv_filename && (
                              <span className={`percent success`}>100%</span>
                            )}
                            {errorFileListData?.length == 1 && (
                              <span className={`percent danger`}>Failed</span>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <div
                          className={`progress-bar ${
                            fileListData?.length == 1 && fileListData[0].csv_filename ? "success" : ""
                          } ${errorFileListData?.length == 1 ? "danger" : ""}`}
                        ></div>
                      </Col>
                    </Row>
                  </div>
                  {errorFileListData?.length == 1 && (
                    <Row>
                      <Col className={`admin-error-message pt-2`} span={24}>
                      Error: File size is too large to be uploaded. Files larger
                      than <br />
                      5mb size are not supported.
                      </Col>
                    </Row>
                      
                  )}
                </>
              )}
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={20}>
                  <Button
                    type="primary"
                    className="mt-4"
                    size="large"
                    disabled={
                      !(
                        audienceName &&
                        fileListData?.length > 0 &&
                        fileListData[0]?.csv_filename
                      )
                    }
                    block
                    onClick={onSave}
                  >
                    Upload File
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
      {modalVisible && (
        <PopupMessageComponent
          open={modalVisible}
          onCancel={closeModalPopup}
          title={modalTitle}
          subTitle={modalSubTitle}
          type={modalType}
          buttons={modalButtons}
        />
      )}
    </>
  );
}
export default CreateAudienceCSV;
